<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <!--
      <img
        id="pp-img"
        :src="us.photo"
        class="img-avatar"
        :alt="us.email" />
      -->
      Welcom, {{us.email}} <i style="font-weight:bold;" class=" fa fa-angle-down" /> &nbsp;&nbsp;&nbsp;
    </template>\
    <template slot="dropdown">
      <b-dropdown-item @click="profile" ><i class="fa fa-user" /> <span id="pp-label"> {{us.email}}</span></b-dropdown-item>
      <b-dropdown-item @click="logout" ><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  mounted() {
     let auth = window.sessionStorage.getItem(this.setting.user_local_);
     if(!auth){
       this.$router.replace(`/auth/login`);
     }else{
       this.us = JSON.parse(auth);
     }

  },
  data: () => {
    return { 
      us:{}
     }
  }, 
  methods:{
    logout(){
      window.sessionStorage.removeItem(this.setting.user_local_);
      this.$router.replace(`/auth/login`);
    },
    profile(){
      this.$router.replace(`/profile`);
    }
  }
}
</script>
